export default __webpack_public_path__ + "static/media/lineArrow.ee6ff1cf.svg";